/**
 * Tubesheet PDF Page 2 Component
 * 
 * Renders the second page of WPS PDF specifically for Tubesheet welding type.
 * Contains:
 * - WPS header with procedure identification
 * - Post Weld Heat Treatment (PWHT) section with tubesheet-specific parameters
 * - Other Variables section with additional welding parameters
 * - Notes section with multi-line text support
 * - Signature footer with prepared/approved signatures
 * 
 * Designed for tube-to-tubesheet welding procedures with specialized requirements
 */

import "../Css/Download_pdf.css";
import Groove_pdf_header from "./Groove_pdf_header WPS";
import PageFooter from "./PageFooter";
import { TubesheetDetailsTable } from "./common";

const Tubesheet_Pdf_Page2 = ({
  page,
  pdf,
  previewuser,
  previewapproved,
}) => {
  return (
    <div className="WPSMainPDF">
      <div id="container" className="WPSflexb">
        <div className="WPSheaderRow">
          {window.innerHeight < 595 && (
            <div style={{ height: `${595 - window.innerHeight}px` }}></div>
          )}
          <br />
          <Groove_pdf_header page={page} pdf={pdf} />
        </div>
        
        {/* POST WELD HEAT TREATMENT */}
        <div id="body" className="WPSContent">
          <div
            className="WPSgroup"
            style={{ position: "relative", top: "5px" }}
          >
            <div className="WPSbasemetal" style={{ width: "100%" }}>
              POST WELD HEAT TREATMENT (QW-407)
            </div>
          </div>
          
          <TubesheetDetailsTable pdf={pdf} type="PostWeldHeatTreatment" />
          
          <br />
          
          {/* Other variables */}
          <div className="WPSgroup">
            <div className="WPSbasemetal">OTHER VARIABLES</div>
          </div>
          
          <TubesheetDetailsTable pdf={pdf} type="OtherVariables" />
          
          {/* Notes */}
          <br />
          
          <div className="WPSgroup">
            <div className="WPSbasemetal">NOTES</div>
          </div>
          
          <table id="table" className="WPSTable10">
            <tbody>
              <tr>
                <td className="Noteswrap">
                  {pdf[0]?.WPSH_Notes != undefined
                    ? pdf[0]?.WPSH_Notes.split("\n").map((i) => {
                        return (
                          <>
                            {i}
                            <br />
                          </>
                        );
                      })
                    : ""}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      
      {/* Footer */}
      <div style={{ position: "fixed", top: "1590px" }}>
        <PageFooter
          pdf={pdf}
          previewuser={previewuser}
          previewapproved={previewapproved}
        />
      </div>
      
      <br />
      <br />
      
      <div style={{ position: "fixed", top: "1680px" }}>
        <table className="WPSfooter">
          <tr>
            <td>Page 2 of 2</td>
          </tr>
        </table>
      </div>
    </div>
  );};

export default Tubesheet_Pdf_Page2; 
